// Copyright (c) 2024 Comsearch, Inc., All rights reserved

import { getUnitLabelForKmAndMiles } from 'helpers/unitConversion'
import { stringMustBeWithinRange } from 'validators/common'

export const validateRadius = (value, error, radiusKmUnit) => {
  if (!value) {
    return
  }
  
  const unit = getUnitLabelForKmAndMiles(radiusKmUnit)
  
  const err = (
    radiusKmUnit === 'SI'
    ? stringMustBeWithinRange(value, 0, 999.999, unit)
    : stringMustBeWithinRange(value, 0, 621.36, unit)
  )

  if (err) {
    error.radiusKm = err
  }
}

